import React from "react";
import {
  ServicesContainer,
  Heading,
  Subtitle,
  Welcome,
  Welcomeimg,
  ImgDiv,
  ChicksWorld,
  WorldImgDiv,
  WorldSubtitle,
  GridWelcome,
  FamilyHeading,
  NestedImgCon,
  ImgNestedDiv,
  EggsImgCon,
  ImgEggsDiv,
  Eggsimg,
  Familiesline,
  WelImgCont,
  WeltextCont,
  CenterSubtitle,
  CenterCont,
  Nestedimg1,
  WorldCont,
  HomeDivSub,
  Headingtt,
  FamilyInnContFam,
  FamilyContainerFam,
  FamiliesSubtitleFam,
  FamilyimgFam,
  FamilyContainerFamBot,
  FamilyInnEvenContFam,
} from "./ServicesElements";
import Specs1 from "../../images/collectionfiff.gif";
import Frame from "../../images/Frame.png";
import Group from "../../images/Group.png";
import a from "../../images/a.png";
import b from "../../images/b.png";
import c from "../../images/c.png";
import d from "../../images/d.png";
import e from "../../images/e.png";
import f from "../../images/f.png";
import g from "../../images/g.png";
import h from "../../images/h.png";
import i from "../../images/i.png";
import j from "../../images/j.png";
import Happister from "../../images/Happister.png";
import Healthrix from "../../images/Healthrix.png";
import Wealthrix from "../../images/Wealthrix.png";
import Peacer from "../../images/Peacer.png";
import Prosperin from "../../images/Prosperin.png";
import stoneFrame from "../../images/stoneframe.png";

const Services = (props) => {
  return (
    <ServicesContainer id="about">
      <Headingtt>A Collection of 10,000 Trippy Chicks</Headingtt>
      <Welcome>
        <WelImgCont>
          <ImgDiv>
            <Welcomeimg style={{ border: "3px solid #828" }} src={Specs1} />
          </ImgDiv>
          <WeltextCont>
            <Subtitle>
              Welcome to the wild world of the Trippy Chicks, a mind-bending
              collection of hallucinogenic bird NFTs (Non-Fungible Tokens) sure
              to inspire wonder and confusion! Spread your wings with the Trippy
              Chicks and enter a wonderful world of possibility!
              <br />
              Every Trippy Chick is a uniquely generated psychedelic bird from
              deep within the Metaversal Mind, hatched from a psychic egg and
              brought into the world through the blockchain and given form by a
              swirling chaotic pattern of colors and shapes. From the mildest
              Widgen to the most majestic Aquilla, the Trippy Chicks are here to
              brighten your world and inspire your creativity with their
              plumage.
              <br />
              Flying the skies of the Metaversal Mind gives the Trippy Chicks a
              colorful explosion of creativity that stays with them throughout
              their life. While each of the Trippy Chicks begins life as one of
              five broad types of birds, their time in the kaleidoscope skies of
              the metaverse touches each one in a unique way, coloring feathers,
              beaks, and eyes, all while reflecting the scintillating shimmers
              of the Metaversal Mind as it contemplates the universe of
              possibilities around it.
              <br />
            </Subtitle>
          </WeltextCont>
        </WelImgCont>
      </Welcome>
      <CenterCont>
        <CenterSubtitle>
          The Trippy Chicks can’t wait to meet you and be an intoxicating
          addition to your collection!
        </CenterSubtitle>
      </CenterCont>
      {/* Slider Section */}
      <NestedImgCon>
        <ImgNestedDiv>
          <Nestedimg1 style={{ transform: "scaleX(-1)" }} src={Group} />
        </ImgNestedDiv>
        <Heading>Our Collection</Heading>
        <ImgNestedDiv>
          <Nestedimg1 src={Group} />
        </ImgNestedDiv>
      </NestedImgCon>
      <div className="img-container">
        <div className="slider">
          <div className="slide-track">
            <div className="slide">
              <img src={a} alt="loading" />
            </div>
            <div className="slide">
              <img src={b} alt="loading" />
            </div>
            <div className="slide">
              <img src={c} alt="loading" />
            </div>
            <div className="slide">
              <img src={d} alt="loading" />
            </div>
            <div className="slide">
              <img src={e} alt="loading" />
            </div>
            <div className="slide">
              <img src={f} alt="loading" />
            </div>
            <div className="slide">
              <img src={g} alt="loading" />
            </div>
            <div className="slide">
              <img src={h} alt="loading" />
            </div>
            <div className="slide">
              <img src={i} alt="loading" />
            </div>
            <div className="slide">
              <img src={j} alt="loading" />
            </div>
            {/* Same 10 slides doubled */}
            <div className="slide">
              <img src={a} alt="loading" />
            </div>
            <div className="slide">
              <img src={b} alt="loading" />
            </div>
            <div className="slide">
              <img src={c} alt="loading" />
            </div>
            <div className="slide">
              <img src={d} alt="loading" />
            </div>
            <div className="slide">
              <img src={e} alt="loading" />
            </div>
            <div className="slide">
              <img src={f} alt="loading" />
            </div>
            <div className="slide">
              <img src={g} alt="loading" />
            </div>
            <div className="slide">
              <img src={h} alt="loading" />
            </div>
            <div className="slide">
              <img src={i} alt="loading" />
            </div>
            <div className="slide">
              <img src={j} alt="loading" />
            </div>
          </div>
        </div>
      </div>
      {/* Trippy Chicks World */}

      <Heading style={{ marginTop: "5%" }}>Trippy chicks world</Heading>
      <ChicksWorld>
        <WorldImgDiv>
          <Welcomeimg src={Frame} />
        </WorldImgDiv>
        <WorldCont>
          <WorldSubtitle>
            The Trippy Chicks project is an expansive project that will be
            exclusive to members who are part of an idealistic community
            providing an NFT collection to people who strive towards manifesting
            their dreams. These birds will attract all that is positive in the
            universe and you will be able to use that energy to work for
            yourself. These birds are rare objects that are highly in demand and
            if you have them you will be able to benefit from the virtues that
            each bird brings to make your dreams a reality. The Trippy Chicks
            are a super-secret metaverse of ten thousand unique psychedelic
            birds in the blockchain which possess superpowers that are till now
            untamed to mankind.
          </WorldSubtitle>
        </WorldCont>
      </ChicksWorld>
      <HomeDivSub>
        <GridWelcome>
          <WorldSubtitle>
            This is the home for super rare lucky magic birds which fall into
            five species. Happister, Healthtrix, Wealthtrix, Peacer, and
            Prosperin. Ancient text scripts suggest if anyone possesses these
            birds, they manifest the underlying superpower to the owner of these
            birds. Every Trippy Chick is a uniquely generated psychedelic bird
            from deep within the Metaverse Mind, hatched from a psychic egg and
            brought into the world through the blockchain. They give rise to a
            superpower belief system that will apply laws of attraction with a
            positive mental attitude.
          </WorldSubtitle>
        </GridWelcome>
      </HomeDivSub>
      {/* Meet with family */}
      <EggsImgCon>
        <ImgEggsDiv>
          <Eggsimg src={stoneFrame} style={{ transform: "scaleX(-1)"}} />
        </ImgEggsDiv>
        <Heading>Meet with families</Heading>
        <ImgEggsDiv>{/* <Eggsimg src={Group4} /> */}</ImgEggsDiv>
      </EggsImgCon>

      <FamilyContainerFam>
        {/* Happister */}
        <FamilyInnContFam>
          <FamilyimgFam src={Happister} />
          <FamilyHeading>Happister</FamilyHeading>
          <div style={{ width: "90%" }}>
            <FamiliesSubtitleFam>
              Anyone who possesses the Happister chick in the metaverse is bound
              to gain a limitless supply of happiness in the metaverse. They
              will be granted the boon of staying positive and happy and go on
              to spread that positivity among loved ones, friends, and the rest
              of the community.
            </FamiliesSubtitleFam>
          </div>
        </FamilyInnContFam>
        <FamilyInnEvenContFam>
          <FamilyimgFam src={Healthrix} />
          <FamilyHeading>Healthrix</FamilyHeading>
          <div style={{ width: "90%" }}>
            <FamiliesSubtitleFam>
              The possessor of Health rix will benefit from a healthy and
              youthful lifestyle. Health can be improved by a balanced intake of
              diet and maintaining your body by partaking in exercise and
              physical activity together with the other community members.
            </FamiliesSubtitleFam>
          </div>
        </FamilyInnEvenContFam>
        <FamilyInnContFam>
          <FamilyimgFam src={Wealthrix} />
          <FamilyHeading>Wealthrix</FamilyHeading>
          <div style={{ width: "90%" }}>
            <FamiliesSubtitleFam>
              Wealthrix is responsible for bringing wealth to your life. Anyone
              who possesses wealthrix will be granted substantial wealth. You
              can further increase your wealth by discussing different ideas
              regarding business and financial matters with your peers in the
              metaverse community.
            </FamiliesSubtitleFam>
          </div>
        </FamilyInnContFam>
      </FamilyContainerFam>

      <FamilyContainerFamBot>
        <FamilyInnEvenContFam >
          <FamilyimgFam src={Peacer} />
          <FamilyHeading>Peacer</FamilyHeading>
          <div style={{ width: "90%" }}>
            <FamiliesSubtitleFam>
              The Peacer trippy chick NFT will bring peace to your life. Even
              after owning whatever you want you can still not achieve inner
              peace. You can achieve this inner peace by the Peacer trippy chich
              and by discussing different ways of the spiritual nature with your
              fellow metaverse community members.
            </FamiliesSubtitleFam>
          </div>
        </FamilyInnEvenContFam>
        <FamilyInnContFam>
          <FamilyimgFam src={Prosperin} />
          <FamilyHeading>Prosperin</FamilyHeading>
          <div style={{ width: "90%" }}>
            <FamiliesSubtitleFam>
              The bearer of the Prosperin trippry chick NFT will be able to lead
              a successful life as the chick is responsible for bringing
              prosperity to one’s life. When you have all the above virtues,
              happiness, wealth, peace, and health, then you will have achieved
              prosperity and lead a successful life in metaverse along your
              community of friends.
            </FamiliesSubtitleFam>
          </div>
        </FamilyInnContFam>
      </FamilyContainerFamBot>
      <EggsImgCon>
        <ImgEggsDiv>{/* <Eggsimg src={Group2} /> */}</ImgEggsDiv>
        <Familiesline>We are happy to see you!</Familiesline>
        <ImgEggsDiv>
          <Eggsimg src={stoneFrame} />
        </ImgEggsDiv>
      </EggsImgCon>
    </ServicesContainer>
  );
};

export default Services;
